/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 25/07/2025 16:27
 *
 */

export class Tools {
  /**
   * Compares two arrays of IDs and returns the added and removed IDs.
   * @param oldIds
   * @param newIds
   */
  public static diffIds(
    oldIds: string[],
    newIds: string[],
  ): { added: string[]; removed: string[] } {
    const oldSet = new Set(oldIds);
    const newSet = new Set(newIds);

    const added = Array.from(newSet).filter((id) => !oldSet.has(id));
    const removed = Array.from(oldSet).filter((id) => !newSet.has(id));

    return { added, removed };
  }

  /**
   * Applies the diff of IDs to the current IDs.
   * @param oldIds
   * @param newIds
   * @param currentIds
   */
  public static applyDiffIds(
    oldIds: string[],
    newIds: string[],
    currentIds: string[],
  ): string[] {
    const { added, removed } = this.diffIds(oldIds, newIds);
    let result = [...currentIds];
    result = result.filter((id) => !removed.includes(id));
    result = Array.from(new Set([...result, ...added]));
    return result;
  }

  public static isExternalLink(value: string): boolean {
    return value?.startsWith('http://') || value?.startsWith('https://');
  }
}
